import React from 'react';
import classnames from 'classnames';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';
import bindOwnClassnamesWithSkin from '@wix/da-shared-react/pkg/utils/bindOwnClassnamesWithSkin';
import Popover from '@wix/da-shared-react/pkg/Popover';

import s from './ConfigPopover.scss';

export interface Props {
  width?: number;
  withPaddings?: boolean;
  className?: string;
  skin?: { [k: string]: string };
  onClose(): void;
}

export class ConfigPopover extends React.Component<Props> {
  static defaultProps = {
    withPaddings: true,
    skin: {},
  };

  private s: Function;

  constructor(props) {
    super(props);
    this.s = bindOwnClassnamesWithSkin(s, props.skin);
  }

  render() {
    const { withPaddings, width, className, onClose, children } = this.props;
    return (
      <Popover
        isOpen={true}
        positionFixed={true}
        width={width}
        onClickOutside={onClose}
        showArrow={false}
        wrapperClassName={classnames(
          'no-theme-skin',
          this.s('tooltip-wrapper'),
          className
        )}
        contentClassName={classnames(
          this.s('tooltip-content'),
          withPaddings && this.s('with-paddings')
        )}
        placement="bottom-end"
        positionOnly
      >
        <ThemeOverride
          className={classnames('no-theme-skin', this.s('theme-wrapper'))}
          theme={ThemeOptions.LIGHT}
        >
          {children}
        </ThemeOverride>
      </Popover>
    );
  }
}

export default ConfigPopover;
